<template>
  <kst-table input-mode :data="dataList">
    <b-table-column
      v-slot="{ column, row }"
      field="Name"
      :label="PackagingCatalog.Name.Label"
    >
      <kst-output error-off field-only
        :field="column.field" :data="row" :catalog="PackagingCatalog"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-qty"
      field="Qty"
      :label="PackagingCatalog.Qty.Label"
    >
      <kst-output error-off field-only
        :field="column.field" :data="row" :catalog="PackagingCatalog"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-price"
      field="SellPrice"
      :label="PackagingCatalog.SellPrice.Label"
    >
      <kst-output error-off field-only
        :field="column.field" :data="row" :catalog="PackagingCatalog"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-weight-full"
      field="Weight"
      :label="PackagingCatalog.Weight.Label"
    >
      <kst-output error-off field-only
        :field="column.field" :data="row" :catalog="PackagingCatalog"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-item-active"
      field="IsActive"
      :label="PackagingCatalog.IsActive.Label"
    >
      <kst-item-active :field="column.field" :data="row" :catalog="PackagingCatalog"/>
    </b-table-column>
  </kst-table>
</template>

<script>
import PackagingCatalog from "../PackagingCatalog.js";

export default {
  props: {
    dataList: Array
  },
  data: () => ({
    PackagingCatalog: PackagingCatalog
  })
}
</script>